import {
  CREATE_TICKET,
  REDEEM_TICKETS,
  REDEEM_TICKET
} from 'types/actions/tickets'

const ticketInitialState = {
  tickets: []
}

export default (state = ticketInitialState, action) => {
  switch (action.type) {
    case CREATE_TICKET:
      return {
        ...state,
        tickets: action.event
      }
    case REDEEM_TICKETS:
      return {
        ...state,
        tickets: action.event
      }
    case REDEEM_TICKET:
      return {
        ...state,
        tickets: action.event
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tickets.js